type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  busy?: boolean;
};

/** One primary per region. The busy state keeps the label — a spinner that replaces the text
 *  hides what the button was about to do. */
export function Button({ variant = 'secondary', busy = false, children, disabled, ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      className={`btn btn--${variant}${rest.className ? ` ${rest.className}` : ''}`}
      disabled={disabled === true || busy}
      aria-busy={busy || undefined}
    >
      {busy && <span className="btn__spinner" aria-hidden="true" />}
      {children}
    </button>
  );
}
